import { makeStyles } from '@fluentui/react';
import '../Styles/Loading.scss';

const useStyles = makeStyles(theme => ({
    root: { position: 'fixed', left: 0, top: 52, width: '100%', height: '100%', backgroundColor: theme.semanticColors.bodyBackground, zIndex: 998 },
}));

interface LoaderProps {
    loadingtext: string;
}

export const QuotesLoader = (props: LoaderProps) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className="loadingscreen">
                <svg width="20%" height="20%" viewBox="0 0 500 300">
                    <rect width="82" height="82" rx="50" ry="50" fill="transparent" />
                    <g className="ci1" transform="matrix(1,0,0,1,0,0)">
                        <circle cx="250" cy="150" r="105" fill="rgb(100,101,164)" />
                        <circle cx="250" cy="150" r="85" fill="white" />
                    </g>
                    <g className="ci2" transform="matrix(1,0,0,1,0,0)">
                        <circle cx="250" cy="150" r="60" fill="rgb(100,101,164)" />
                        <circle cx="250" cy="150" r="40" fill="white" />
                    </g>
                    <g className="ci4" transform="matrix(1,0,0,1,0,0)">
                        <circle cx="250" cy="150" r="20" fill="rgb(100,101,164)" />
                        <circle cx="250" cy="150" r="0" fill="white" />
                    </g>
                </svg>
                <div className="loadingdesctxt">{props.loadingtext}</div>
            </div>
        </div>
    );
};
